
export default {
  name: 'PoweredBy',
  data() {
    return {
      cardLogos: ['visa.png', 'mastercard.png', 'amex.png', 'jcb.png', 'discover.png']
    }
  }
}
